import { NgModule } from '@angular/core';

import { GiantSidebarComponent } from './sidebar.component';

@NgModule({
    declarations: [
        GiantSidebarComponent
    ],
    exports     : [
        GiantSidebarComponent
    ]
})
export class GiantSidebarModule
{
}
